import { useLocation } from 'react-router-dom';
import { useEffect, useState, useRef } from 'react';

/**
 * Page transition loader that shows a loading bar during route changes.
 * Uses useLocation instead of useNavigation for compatibility with BrowserRouter.
 */
export default function PageTransitionLoader() {
  const location = useLocation();
  const [isVisible, setIsVisible] = useState(false);
  const previousPath = useRef(location.pathname);

  useEffect(() => {
    // Detect route change
    if (previousPath.current !== location.pathname) {
      setIsVisible(true);
      previousPath.current = location.pathname;

      // Hide after a short delay (simulates page load complete)
      const timer = setTimeout(() => setIsVisible(false), 300);
      return () => clearTimeout(timer);
    }
  }, [location.pathname]);

  if (!isVisible) return null;

  return (
    <div className="fixed inset-x-0 top-0 z-50 h-1 overflow-hidden bg-primary/20">
      <div
        className="h-full animate-pulse bg-primary"
        style={{
          animation: 'pageLoadProgress 0.3s ease-out forwards',
        }}
      />
      <style>{`
        @keyframes pageLoadProgress {
          from { width: 0%; }
          to { width: 100%; }
        }
      `}</style>
    </div>
  );
}
